import script from "./CellEditMenuWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./CellEditMenuWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./CellEditMenuWrapper.vue?vue&type=style&index=0&id=b822a10e&lang=css"

const __exports__ = script;

export default __exports__